import Carousel from './carousel';

class PrimarySliderTeaser extends Carousel {
  constructor(selector: any = '.js-o-primary-slider-teaser', settings: object = {}) {
    const TIME = 5000;
    const SPEED = 800;

    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const carousel: HTMLElement | null | undefined = el.closest('.o-primary-slider-teaser');
    const pagination: HTMLElement | null | undefined = carousel?.querySelector('.o-primary-slider-teaser__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      speed: SPEED,
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      navigation: {
        prevEl: carousel ? carousel.querySelector('.swiper-button-prev--arrow') : '.swiper-button-prev',
        nextEl: carousel ? carousel.querySelector('.swiper-button-next--arrow') : '.swiper-button-next',
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: () => {
          pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
        },
      },
      observer: true,
      observeParents: true,
    });
  }

  init() {
    super.init();
  }
}

export default PrimarySliderTeaser;
